import {Component, OnDestroy, OnInit} from '@angular/core';
import {Subject, takeUntil} from 'rxjs';
import {DropdownOption} from '../../../../../../models/dropdown-option.model';
import * as Validation from '../../../../../shared/constants/validation.constants';
import {FormControl, FormGroup} from '@angular/forms';
import {Store} from '@ngrx/store';
import * as fromRoot from '../../../../../../state/app.state';
import {CommonService} from '../../../../../shared/services/common.service';

import {Filter} from '../../../../../../models/filter';
import {GroupDashboardService} from '../../../services/group-dashboard.service';
import {FetchUserStatusListFilterRequest} from '../../../core/group-dashboard.actions';
import {userStatusListFilter} from '../../../core/group-dashboard.selector';
import {roles} from '../../../../../shared/constants/common.constants';
import {ActivatedRoute} from '@angular/router';

@Component({
  selector: 'app-participant-weight-information-filter',
  templateUrl: './participant-weight-information-filter.component.html',
  styleUrls: ['./participant-weight-information-filter.component.css']
})
export class ParticipantWeightInformationFilterComponent implements OnInit, OnDestroy {

  private readonly OnDestroy: Subject<any> = new Subject<any>();
  sessionFilterList: DropdownOption[] = [
    {
      key: 1,
      value: 'Up to S26',
    },
    {
      key: 2,
      value: 'After S26',
    },
  ];

  roleFilterList: DropdownOption[] = [
    {
      key: roles.adult,
      value: 'Adult',
    },
    {
      key: roles.participant,
      value: 'Participant',
    },
  ];

  statusFilterList: DropdownOption[] = [];
  errorMessages: any = {};
  validation = Validation;
  errorMessageMap = {
    'session': {},
    'status': {},
    'searchText': {},
  }

  form = new FormGroup({
    role: new FormControl([roles.participant]),
    session: new FormControl(1),
    status: new FormControl(null),
    searchText: new FormControl(null),
    groupId: new FormControl(null),
  })

  clientOptions: Filter = {
    list: [],
    total: 0,
    pageNumber: 1,
    limit: 10,
    hasNext: false,
    hasPrev: false,
    loading: false
  };

  groupOptions: Filter = {
    list: [],
    total: 0,
    pageNumber: 1,
    limit: 10,
    hasNext: false,
    hasPrev: false,
    loading: false
  };

  constructor(
    private store: Store<fromRoot.State>,
    private commonService: CommonService,
    private groupDashboardService: GroupDashboardService,
    private route: ActivatedRoute,
  ) {
    this.store.dispatch(FetchUserStatusListFilterRequest())
  }

  ngOnInit() {
    const filters = this.form.getRawValue();
    this.groupDashboardService.onParticipantWeightInformationFilterChange.next(filters);

    this.store.select(userStatusListFilter)
      .pipe(takeUntil(this.OnDestroy))
      .subscribe((data) => {
        this.statusFilterList = data.list;
      });

    this.form.patchValue({
      groupId: this.route.snapshot.params['groupId'],
    })
  }

  apply() {
    // ERROR CHECK IN THE FORM//
    if (this.form.invalid) {
      this.checkForErrors();
      return;
    }
    if (!this.form.dirty) { // check is there any change
      return;
    }
    // changes just applied, so marking the form as un-dirty to avoid applying same filters again without changing anything
    this.form.markAsPristine();

    // EXTRACT VALUE FROM FORM//
    const filters = this.form.getRawValue();
    this.groupDashboardService.onParticipantWeightInformationFilterChange.next(filters)
  }

  checkForErrors(currentField ?: string) {
    this.errorMessages = {
      ...this.errorMessages,
      ...(this.commonService.checkFormValidation(this.form, this.errorMessageMap, currentField))
    };
  }

  ngOnDestroy() {
    this.OnDestroy.next(null);
    this.OnDestroy.complete();
  }

}
